import eventBus from '~/events/eventBus'
import eventDefinitions from '~/events/eventDefinitions'

eventBus.$on(eventDefinitions.NOT_FOUND.PAGE_VIEW, () => {
  //
})
